module.exports = __webpack_public_path__ + "static/media/2_image1.eef58d0b.jpg";